// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero */
.detail-hero {
  background: linear-gradient(160deg, var(--cream-dark) 0%, var(--cream) 100%);
  padding: 160px 0 60px;
  border-bottom: 1px solid rgba(200, 134, 10, 0.15);
}

.back-btn {
  background: none;
  border: none;
  font-family: 'Poppins', sans-serif;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--gold-dark);
  cursor: pointer;
  padding: 0;
  margin-bottom: 28px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: gap 0.2s ease;
}

.back-btn:hover {
  gap: 10px;
}

.detail-hero-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 28px;
  align-items: start;
}

.detail-hero-icon {
  width: 88px;
  height: 88px;
  background: linear-gradient(135deg, rgba(200,134,10,0.12), rgba(196,72,10,0.07));
  border: 2px solid rgba(200,134,10,0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  flex-shrink: 0;
}

.verified-badge-lg {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #4A6E2A, #6A8E4A);
  color: var(--white);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}

.detail-hero-info h1 {
  font-size: 2.2rem;
  color: var(--brown);
  margin-bottom: 8px;
  line-height: 1.2;
}

.detail-tagline {
  font-size: 0.95rem;
  color: var(--text-mid);
  margin-bottom: 14px;
  line-height: 1.7;
}

.detail-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 14px;
}

.detail-meta-row span {
  font-size: 0.85rem;
  color: var(--text-light);
  display: flex;
  align-items: center;
  gap: 4px;
}

.detail-activities {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.activity-tag {
  font-size: 0.75rem;
  padding: 4px 12px;
  background: rgba(200,134,10,0.1);
  color: var(--gold-dark);
  border-radius: 20px;
  font-weight: 500;
}

.detail-hero-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
  min-width: 200px;
}

.detail-hero-actions .btn-primary,
.detail-hero-actions .btn-outline {
  text-align: center;
  font-size: 0.9rem;
  padding: 12px 20px;
}

/* Stats */
.detail-stats-section {
  background: var(--white);
  padding: 48px 0;
}

.detail-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.detail-stat {
  text-align: center;
  padding: 28px 20px;
}

.detail-stat-num {
  display: block;
  font-size: 2rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 6px;
}

.detail-stat-label {
  font-size: 0.82rem;
  color: var(--text-light);
  font-weight: 500;
}

/* About */
.detail-about-section {
  background: var(--cream);
}

.detail-about-grid {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 40px;
  align-items: start;
}

.detail-about-text .badge {
  margin-bottom: 10px;
}

.detail-about-text h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}

.detail-about-text p {
  color: var(--text-mid);
  line-height: 1.9;
  margin-bottom: 14px;
  font-size: 0.95rem;
}

/* Contact Card */
.detail-contact-card {
  position: sticky;
  top: 130px;
}

.detail-contact-card h3 {
  font-size: 1.1rem;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(200,134,10,0.15);
}

.detail-contact-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-contact-list li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.contact-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
  margin-top: 1px;
}

.detail-contact-list > li > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contact-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-light);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.contact-value {
  font-size: 0.88rem;
  color: var(--text-dark);
  font-weight: 500;
}

/* Social Activities */
.detail-activities-section {
  background: var(--white);
}

.detail-activities-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.detail-activity-card {
  text-align: center;
}

.detail-activity-icon {
  font-size: 2.4rem;
  margin-bottom: 14px;
}

.detail-activity-card h3 {
  font-size: 1rem;
  margin-bottom: 8px;
}

.detail-activity-card p {
  font-size: 0.85rem;
  color: var(--text-mid);
  line-height: 1.7;
}

/* Gallery */
.detail-gallery-section {
  background: var(--cream);
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.gallery-item {
  aspect-ratio: 1;
  background: linear-gradient(135deg, rgba(200,134,10,0.1), rgba(196,72,10,0.06));
  border: 1.5px solid rgba(200,134,10,0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.gallery-item:hover {
  transform: scale(1.04);
}

.gallery-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(44,26,6,0.85), transparent);
  color: var(--white);
  font-size: 0.65rem;
  padding: 8px 6px 6px;
  text-align: center;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.gallery-note {
  font-size: 0.82rem;
  color: var(--text-light);
  text-align: center;
}

/* Events */
.detail-events-section {
  background: var(--white);
}

.detail-events-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 800px;
  margin: 0 auto;
}

.detail-event-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
}

.event-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.event-dot.upcoming { background: var(--green); }
.event-dot.past { background: var(--gold); }

.detail-event-info {
  flex: 1 1;
}

.detail-event-info h4 {
  font-size: 0.95rem;
  color: var(--brown);
  margin-bottom: 4px;
}

.detail-event-info span {
  font-size: 0.82rem;
  color: var(--text-light);
}

.detail-event-status {
  font-size: 0.78rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  white-space: nowrap;
}

.detail-event-status.upcoming {
  background: rgba(74,110,42,0.1);
  color: var(--green);
}

.detail-event-status.past {
  background: rgba(200,134,10,0.1);
  color: var(--gold-dark);
}

/* Generic (no detailed data) */
.generic-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  padding: 20px 0;
}

.generic-info h3 {
  font-size: 1.3rem;
  margin-bottom: 14px;
}

.generic-info p {
  color: var(--text-mid);
  line-height: 1.8;
  margin-bottom: 20px;
}

.generic-stats {
  display: flex;
  gap: 24px;
}

.generic-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.generic-stat span {
  font-size: 1.6rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--gold), var(--orange));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.generic-stat label {
  font-size: 0.78rem;
  color: var(--text-light);
  font-weight: 500;
}

.coming-soon-card {
  text-align: center;
  padding: 48px 32px;
  background: linear-gradient(135deg, rgba(200,134,10,0.05), rgba(196,72,10,0.03));
}

.coming-soon-card h3 {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.coming-soon-card p {
  font-size: 0.88rem;
  color: var(--text-mid);
  line-height: 1.8;
}

/* Bottom CTA */
.detail-bottom-cta {
  background: linear-gradient(135deg, var(--cream-dark), var(--cream));
}

.detail-bottom-cta h2 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.detail-bottom-cta p {
  color: var(--text-mid);
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.8;
}

/* Responsive */
@media (max-width: 1024px) {
  .detail-stats-grid { grid-template-columns: repeat(2, 1fr); }
  .detail-activities-grid { grid-template-columns: repeat(2, 1fr); }
  .gallery-grid { grid-template-columns: repeat(3, 1fr); }
  .detail-about-grid { grid-template-columns: 1fr; }
  .detail-contact-card { position: static; }
}

@media (max-width: 768px) {
  .detail-hero-content {
    grid-template-columns: 1fr;
  }

  .detail-hero-icon { display: none; }

  .detail-hero-actions {
    flex-direction: row;
    min-width: unset;
  }

  .detail-hero-info h1 { font-size: 1.7rem; }

  .generic-detail-grid { grid-template-columns: 1fr; }
}

@media (max-width: 560px) {
  .detail-stats-grid { grid-template-columns: repeat(2, 1fr); }
  .detail-activities-grid { grid-template-columns: 1fr; }
  .gallery-grid { grid-template-columns: repeat(2, 1fr); }
  .detail-hero-actions { flex-direction: column; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SanthaDetail.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,4EAA4E;EAC5E,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gFAAgF;EAChF,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+EAA+E;EAC/E,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oEAAoE;EACpE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB,wBAAwB,EAAE;AAChD,kBAAkB,uBAAuB,EAAE;;AAE3C;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,qBAAqB,qCAAqC,EAAE;EAC5D,0BAA0B,qCAAqC,EAAE;EACjE,gBAAgB,qCAAqC,EAAE;EACvD,qBAAqB,0BAA0B,EAAE;EACjD,uBAAuB,gBAAgB,EAAE;AAC3C;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA,oBAAoB,aAAa,EAAE;;EAEnC;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,uBAAuB,iBAAiB,EAAE;;EAE1C,uBAAuB,0BAA0B,EAAE;AACrD;;AAEA;EACE,qBAAqB,qCAAqC,EAAE;EAC5D,0BAA0B,0BAA0B,EAAE;EACtD,gBAAgB,qCAAqC,EAAE;EACvD,uBAAuB,sBAAsB,EAAE;AACjD","sourcesContent":["/* Hero */\n.detail-hero {\n  background: linear-gradient(160deg, var(--cream-dark) 0%, var(--cream) 100%);\n  padding: 160px 0 60px;\n  border-bottom: 1px solid rgba(200, 134, 10, 0.15);\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--gold-dark);\n  cursor: pointer;\n  padding: 0;\n  margin-bottom: 28px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: gap 0.2s ease;\n}\n\n.back-btn:hover {\n  gap: 10px;\n}\n\n.detail-hero-content {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 28px;\n  align-items: start;\n}\n\n.detail-hero-icon {\n  width: 88px;\n  height: 88px;\n  background: linear-gradient(135deg, rgba(200,134,10,0.12), rgba(196,72,10,0.07));\n  border: 2px solid rgba(200,134,10,0.2);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  flex-shrink: 0;\n}\n\n.verified-badge-lg {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #4A6E2A, #6A8E4A);\n  color: var(--white);\n  font-size: 0.78rem;\n  font-weight: 600;\n  padding: 5px 14px;\n  border-radius: 20px;\n  letter-spacing: 0.5px;\n  margin-bottom: 10px;\n}\n\n.detail-hero-info h1 {\n  font-size: 2.2rem;\n  color: var(--brown);\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.detail-tagline {\n  font-size: 0.95rem;\n  color: var(--text-mid);\n  margin-bottom: 14px;\n  line-height: 1.7;\n}\n\n.detail-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.detail-meta-row span {\n  font-size: 0.85rem;\n  color: var(--text-light);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.detail-activities {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.activity-tag {\n  font-size: 0.75rem;\n  padding: 4px 12px;\n  background: rgba(200,134,10,0.1);\n  color: var(--gold-dark);\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n.detail-hero-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex-shrink: 0;\n  min-width: 200px;\n}\n\n.detail-hero-actions .btn-primary,\n.detail-hero-actions .btn-outline {\n  text-align: center;\n  font-size: 0.9rem;\n  padding: 12px 20px;\n}\n\n/* Stats */\n.detail-stats-section {\n  background: var(--white);\n  padding: 48px 0;\n}\n\n.detail-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.detail-stat {\n  text-align: center;\n  padding: 28px 20px;\n}\n\n.detail-stat-num {\n  display: block;\n  font-size: 2rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 6px;\n}\n\n.detail-stat-label {\n  font-size: 0.82rem;\n  color: var(--text-light);\n  font-weight: 500;\n}\n\n/* About */\n.detail-about-section {\n  background: var(--cream);\n}\n\n.detail-about-grid {\n  display: grid;\n  grid-template-columns: 1fr 340px;\n  gap: 40px;\n  align-items: start;\n}\n\n.detail-about-text .badge {\n  margin-bottom: 10px;\n}\n\n.detail-about-text h2 {\n  font-size: 2rem;\n  margin-bottom: 20px;\n}\n\n.detail-about-text p {\n  color: var(--text-mid);\n  line-height: 1.9;\n  margin-bottom: 14px;\n  font-size: 0.95rem;\n}\n\n/* Contact Card */\n.detail-contact-card {\n  position: sticky;\n  top: 130px;\n}\n\n.detail-contact-card h3 {\n  font-size: 1.1rem;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(200,134,10,0.15);\n}\n\n.detail-contact-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.detail-contact-list li {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.contact-icon {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.detail-contact-list > li > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.contact-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--text-light);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.contact-value {\n  font-size: 0.88rem;\n  color: var(--text-dark);\n  font-weight: 500;\n}\n\n/* Social Activities */\n.detail-activities-section {\n  background: var(--white);\n}\n\n.detail-activities-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n}\n\n.detail-activity-card {\n  text-align: center;\n}\n\n.detail-activity-icon {\n  font-size: 2.4rem;\n  margin-bottom: 14px;\n}\n\n.detail-activity-card h3 {\n  font-size: 1rem;\n  margin-bottom: 8px;\n}\n\n.detail-activity-card p {\n  font-size: 0.85rem;\n  color: var(--text-mid);\n  line-height: 1.7;\n}\n\n/* Gallery */\n.detail-gallery-section {\n  background: var(--cream);\n}\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.gallery-item {\n  aspect-ratio: 1;\n  background: linear-gradient(135deg, rgba(200,134,10,0.1), rgba(196,72,10,0.06));\n  border: 1.5px solid rgba(200,134,10,0.15);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.5rem;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.gallery-item:hover {\n  transform: scale(1.04);\n}\n\n.gallery-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(to top, rgba(44,26,6,0.85), transparent);\n  color: var(--white);\n  font-size: 0.65rem;\n  padding: 8px 6px 6px;\n  text-align: center;\n  font-weight: 600;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.gallery-item:hover .gallery-overlay {\n  opacity: 1;\n}\n\n.gallery-note {\n  font-size: 0.82rem;\n  color: var(--text-light);\n  text-align: center;\n}\n\n/* Events */\n.detail-events-section {\n  background: var(--white);\n}\n\n.detail-events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.detail-event-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 24px;\n}\n\n.event-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.event-dot.upcoming { background: var(--green); }\n.event-dot.past { background: var(--gold); }\n\n.detail-event-info {\n  flex: 1;\n}\n\n.detail-event-info h4 {\n  font-size: 0.95rem;\n  color: var(--brown);\n  margin-bottom: 4px;\n}\n\n.detail-event-info span {\n  font-size: 0.82rem;\n  color: var(--text-light);\n}\n\n.detail-event-status {\n  font-size: 0.78rem;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.detail-event-status.upcoming {\n  background: rgba(74,110,42,0.1);\n  color: var(--green);\n}\n\n.detail-event-status.past {\n  background: rgba(200,134,10,0.1);\n  color: var(--gold-dark);\n}\n\n/* Generic (no detailed data) */\n.generic-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  padding: 20px 0;\n}\n\n.generic-info h3 {\n  font-size: 1.3rem;\n  margin-bottom: 14px;\n}\n\n.generic-info p {\n  color: var(--text-mid);\n  line-height: 1.8;\n  margin-bottom: 20px;\n}\n\n.generic-stats {\n  display: flex;\n  gap: 24px;\n}\n\n.generic-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.generic-stat span {\n  font-size: 1.6rem;\n  font-weight: 800;\n  background: linear-gradient(135deg, var(--gold), var(--orange));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.generic-stat label {\n  font-size: 0.78rem;\n  color: var(--text-light);\n  font-weight: 500;\n}\n\n.coming-soon-card {\n  text-align: center;\n  padding: 48px 32px;\n  background: linear-gradient(135deg, rgba(200,134,10,0.05), rgba(196,72,10,0.03));\n}\n\n.coming-soon-card h3 {\n  font-size: 1.2rem;\n  margin-bottom: 10px;\n}\n\n.coming-soon-card p {\n  font-size: 0.88rem;\n  color: var(--text-mid);\n  line-height: 1.8;\n}\n\n/* Bottom CTA */\n.detail-bottom-cta {\n  background: linear-gradient(135deg, var(--cream-dark), var(--cream));\n}\n\n.detail-bottom-cta h2 {\n  font-size: 2rem;\n  margin-bottom: 10px;\n}\n\n.detail-bottom-cta p {\n  color: var(--text-mid);\n  max-width: 500px;\n  margin: 0 auto;\n  line-height: 1.8;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .detail-stats-grid { grid-template-columns: repeat(2, 1fr); }\n  .detail-activities-grid { grid-template-columns: repeat(2, 1fr); }\n  .gallery-grid { grid-template-columns: repeat(3, 1fr); }\n  .detail-about-grid { grid-template-columns: 1fr; }\n  .detail-contact-card { position: static; }\n}\n\n@media (max-width: 768px) {\n  .detail-hero-content {\n    grid-template-columns: 1fr;\n  }\n\n  .detail-hero-icon { display: none; }\n\n  .detail-hero-actions {\n    flex-direction: row;\n    min-width: unset;\n  }\n\n  .detail-hero-info h1 { font-size: 1.7rem; }\n\n  .generic-detail-grid { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 560px) {\n  .detail-stats-grid { grid-template-columns: repeat(2, 1fr); }\n  .detail-activities-grid { grid-template-columns: 1fr; }\n  .gallery-grid { grid-template-columns: repeat(2, 1fr); }\n  .detail-hero-actions { flex-direction: column; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
